import { useState, createContext, useContext } from "react";
import { useLogin } from "hooks";

const GlobalContext = createContext();

const GlobalProvider = ({ children }) => {
  const [reportModalVisible, setReportModalVisible] = useState(false);
  const [userModalVisible, setUserModalVisible] = useState(false);
  const [
    parentalControlModalVisible,
    setParentalControlModalVisible,
  ] = useState(false);

  const [contactModalVisible, setContactModalVisible] = useState(false);
  const [carModalVisible, setCarModalVisible] = useState(false);
  const [videoModalVisible, setVideoModalVisible] = useState(false);
  const [report, setReport] = useState(false);
  const [chatModalVisible, setChatModalVisible] = useState(false);
  const [legalModalVisible, setLegalModalVisible] = useState(false);
  const [openShared, setOpenShared] = useState(false);

  const [video, setVideo] = useState(null);
  const [parentalData, setParentalData] = useState(null);
  const [chat, setChat] = useState(null);
  const [car, setCar] = useState(null);
  const [contact, setContact] = useState(null);
  const [userData, setUserData] = useState(null);
  const { isAuthed, currentUser, handleSetUser } = useLogin();

  const [openAlert, setOpenAlert] = useState(false);
  const [dataAlert, setAlert] = useState("");

  const [isShowModal, setShowModal] = useState(false);
  const [currentDataModal, setDataModal] = useState(null);

  const toggleAlert = (data) => {
    setAlert(data);
    setOpenAlert(!openAlert);
  };

  const toggleContactModal = (data) => {
    setContact(data);
    setContactModalVisible(!contactModalVisible);
  };

  const toggleChatModal = (data) => {
    setChat(data);
    setChatModalVisible(!chatModalVisible);
  };

  const toggleVideoModal = (data) => {
    setVideo(data);
    setVideoModalVisible(!videoModalVisible);
  };

  const toggleCarModal = (data) => {
    setCar(data);
    setCarModalVisible(!carModalVisible);
  };

  const toggleReportModal = (data) => {
    setReport(data);
    setReportModalVisible(!reportModalVisible);
  };

  const toggleUserModal = (data) => {
    setUserData(data);
    setUserModalVisible(!userModalVisible);
  };

  const toggleParentalControlModal = (data) => {
    setParentalData(data);
    setParentalControlModalVisible(!parentalControlModalVisible);
  };

  const toggleLegalModal = () => {
    setLegalModalVisible(!legalModalVisible);
  };

  const toggleOpenShared = () => {
    setOpenShared(!openShared);
  };

  const toggleModal = (data) => {
    setDataModal(data);
    setShowModal((s) => !s);
  };

  return (
    <GlobalContext.Provider
      value={{
        // current users logged
        isAuthed,
        currentUser,
        handleSetUser,

        // getters
        reportModalVisible,
        userModalVisible,
        parentalControlModalVisible,
        parentalData,
        userData,
        report,
        contactModalVisible,
        carModalVisible,
        contact,
        car,
        videoModalVisible,
        video,
        chatModalVisible,
        legalModalVisible,
        chat,
        openShared,
        dataAlert,
        openAlert,
        currentDataModal,
        isShowModal,
        // setters
        toggleModal,
        toggleAlert,
        toggleChatModal,
        toggleContactModal,
        toggleCarModal,
        toggleVideoModal,
        toggleReportModal,
        toggleUserModal,
        toggleParentalControlModal,
        toggleLegalModal,
        toggleOpenShared,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

const useGlobalContext = () => useContext(GlobalContext);
export { GlobalProvider, useGlobalContext };
export default GlobalContext;
